import useSelectR from "./useSelectR";

export default useSelectR;
